import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as React from 'react';

import EmptyListPlaceholder from '../../../common/EmptyListPlaceholder/EmptyListPlaceholder';
import { ROLE, TASK_TABS_CONSTANTS } from '../../../../const';
import * as gradebookActions from '../../../../actions/classroom/gradebookActions';
import * as classroomActions from '../../../../actions/classroom/classroomActions';
import GradesTasksStudentRow from './GradesTasksStudentRow';
import GradesTasksHeader from './GradesTasksHeader';
import GradesTasksTopBar from './GradesTasksTopBar';
import { ScrollToTop } from '@netexknowledge/smart-components';

class GradesTasks extends React.Component {
  static propTypes = {
    classroomId: PropTypes.string.isRequired,
    tasks: PropTypes.array.isRequired,
    tasksFilterParams: PropTypes.object,
    classroom: PropTypes.object,
    gradeBookActions: PropTypes.object,
    classroomActions: PropTypes.object
  };

  state = {
    tasksPage: 1,
    studentsPage: 1
  };

  constructor(props) {
    super(props);
    this.moreTasks = this.moreTasks.bind(this);
    this.moreStudents = this.moreStudents.bind(this);
  }

  componentDidMount() {
    const { classroom, classroomId, classroomActions, tasksFilterParams, gradeBookActions } = this.props;
    classroomActions.getClassroomParticipants(classroom.id);
    gradeBookActions.loadTasks(classroomId, tasksFilterParams || { status: TASK_TABS_CONSTANTS.IN_PROGRESS });
  }

  moreTasks() {
    const { classroomId, gradeBookActions } = this.props;
    const { tasksPage } = this.state;
    this.setState({ tasksPage: tasksPage + 1 });
    gradeBookActions.nextPageTasks(
      classroomId,
      tasksPage + 1,
      tasksFilterParams || { status: TASK_TABS_CONSTANTS.IN_PROGRESS }
    );
  }

  moreStudents() {
    const { studentsPage } = this.state;
    this.setState({ studentsPage: studentsPage + 1 });
  }

  render() {
    const { tasks, students } = this.props;
    const { studentsPage } = this.state;

    if (!students || tasks.length === 0) {
      return (
        <div className="right-content">
          <EmptyListPlaceholder label="tasks.noTasks" hiddenButton={() => true} />
        </div>
      );
    }

    // const students = students
    // TODO: uncomment when we have pagination
    //   .sort((a, b) => a.name.localeCompare(b.name))
    //   .slice(0, studentsPage * 10);

    return (
      <div className="right-content">
        <GradesTasksTopBar
          moreStudents={this.moreStudents}
          moreTasks={this.moreTasks}
          onTaskFilterSelectorChanged={value => this.setState({ tasksFilterParams: value })}
          studentsLength={students.length}
          tasksLength={tasks.length}
        />

        <div className="grades-list">
          <div className="scrollToTop-bnt-wrapper">
            <ScrollToTop contentQuerySelector=".students-list"></ScrollToTop>
          </div>
          <GradesTasksHeader tasks={tasks} />

          <div className="students-list">
            {students.map(student => {
              const studentAttempts = tasks.map(t => ({
                ...t.studentAttempts[student._id],
                taskId: t.id
              }));
              const restultSummary = tasks.map(t => {
                if (t.resultSummary[student._id]) {
                  return {
                    ...t.resultSummary[student._id],
                    taskId: t.id
                  };
                }
              });
              return (
                <GradesTasksStudentRow
                  key={student._id}
                  student={student}
                  studentAttempts={studentAttempts}
                  resultSummary={restultSummary}
                  tasks={tasks}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GradesTasks);

function mapStateToProps(state) {
  return {
    students:
      state.classrooms.selectedClassroom.participants.filter(participant => participant.role === ROLE.STUDENT) || [],
    classroom: state.classrooms.selectedClassroom.classroom,
    tasksFilterParams: state.gradebook.tasksFilterParams
  };
}

function mapDispatchToProps(dispatch) {
  return {
    gradeBookActions: bindActionCreators(gradebookActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch)
  };
}
